<template>
  <div class="page">
    <form class="login-form" v-if="!token" v-on:keyup.enter="formSubmit">
      <input type="text" class="login-input" placeholder="username" v-model="username" :disabled="loggingIn">
      <input type="password" class="login-input" placeholder="password" v-model="password" :disabled="loggingIn">
      <div class="form-actions">
        <router-link class="subtle-link" to="/password-reset">Trouble logging in?</router-link>
        <button class="login-button"
          type="button"
          @click="login({username, password})"
          >
          Log In
        </button>
      </div>
    </form>
    <div class="login-form" v-if="token">
      {{token}}
      You are logged in.
      <div class="form-actions">
        <router-link to="/" class="subtle-link">Home</router-link>
        <button class="login-button" @click="logout()">Log Out</button>
      </div>
    </div>
    <div class="login-message"
      v-for="notification in notifications"
      :key="notification.message"
      :class="{error: notification.type === 'error'}"
    >
      {{notification.message}}
      <button type="button" class="close-button" @click="clearNotifications()">x</button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  methods: {
    ...mapActions([
      'login',
      'logout',
      'clearNotifications',
    ]),
    formSubmit() {
      this.login({ username: this.username, password: this.password });
    },
  },
  computed: mapState({
    loggingIn: state => state.auth.loggingIn,
    token: state => state.auth.authToken,
    notifications: state => state.auth.notifications,
  }),
  data() {
    return {
      username: null,
      password: null,
    };
  },
};
</script>

<style lang="scss" scoped>
.page {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.login-form {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10vh;
  padding: 2em 2em 0.5em 2em;
  border: 1px solid black;
  border-radius: 3px;
  background: white;
  box-shadow: 2px 2px 2px #aaa;
}

.login-input {
  width: 15em;
  margin: 0.25em;
  border: 1px solid black;
  border-radius: 3px;
  padding: 0.3em;
}

.login-button {
  flex: 1;
  margin: 0.5em 0.5em 0.5em 1em;
  background: #eee;
  border: 1px solid black;
  border-radius: 3px;
  box-shadow: 2px 2px 2px #aaa;
  padding: 0.5em;
  &:active {
    box-shadow: none;
  }
}

.subtle-link {
  color: #999;
  font-size: 0.8rem;
  height: 1.5em;
  margin-top: 1.5em;
}

.form-actions {
  width: 100%;
  display: flex;
  justify-content: space-between;
  * {
    display: block;
  }
}

.login-message {
  width: 15em;
  background: white;
  border: 1px solid green;
  border-radius: 3px;
  margin: 1em;
  padding: 1em;
  &.error {
    border: 1px solid red;
  }
  position: relative;
}
.close-button {
  position: absolute;
  top: 0.25em;
  right: 0.25em;
  border: none;
  border-radius: 3px;
  background: transparent;
  padding: 0.1em 0.5em;
  &:hover {
    background: #aaa;
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue?1b91dd20